import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { useAuth } from "../../AuthContext";
import logRocketLauncher from "../../Shared/utils/logRocketLauncher";
import Loading from "./loading";
import { useEnvironment } from "./EnvironmentProvider/EnvironmentProvider";
import { useSWRConfig } from "swr";
import { clearAuthenticatedCache } from "../../SWR/Utilities/swrKeys";
export const Logout = () => {
    const { resetContext } = useAuth();
    const { isLogRocketEnabled } = useEnvironment();
    const { mutate } = useSWRConfig();
    useEffect(() => {
        if (isLogRocketEnabled === true) {
            logRocketLauncher.logout();
        }
        // Clear authenticated user data from SWR cache
        clearAuthenticatedCache(mutate);
        // Clear the saved cache before leaving the page; code after location.replace is not guaranteed to run.
        try {
            window.localStorage.removeItem("app-cache");
        }
        catch (_a) {
            // Storage is unavailable; nothing was saved.
        }
        resetContext();
        window.location.replace("/Refresh/Logout");
    }, []);
    return _jsx(Loading, {});
};
